import { Component, OnInit } from "@angular/core";
import { LocaleService } from "src/app/shared/services/locale.service";
import { Observable } from "rxjs";

@Component({
  selector: "app-agb",
  templateUrl: "./agb.component.html",
  styleUrls: ["./agb.component.scss"],
})
export class AgbComponent implements OnInit {
  locale: Observable<string | null>;
  constructor(private localeService: LocaleService) {}

  ngOnInit(): void {
    this.locale = this.localeService.getCurrentLocale();
  }
}
